import { Navigate, useLocation } from "react-router-dom";
import { isBilling } from "@prism/shared/constants";
import { useAuth } from "../context/AuthContext.jsx";

/** Billing desk guard (4c): SUPER_ADMIN, ADMIN, ACCOUNTANT. Others bounce to their home. */
export function BillingRoute({ children }) {
  const { authenticated, user } = useAuth();
  const location = useLocation();
  if (!authenticated) return <Navigate to="/login" replace state={{ from: location }} />;
  if (!isBilling(user?.role)) return <Navigate to="/" replace />;
  return children;
}
